import { useState, useEffect, useRef } from 'react';
import { Tooltip } from '@mui/material';
import ReviewColorStageIcon from '../../../assets/customIcons/reviewColorStageIcon';
import StyledWrapper from '../../../pages/IndividualProgram/style';
import { getStatusColor } from '../../../utils/utilFunctions';

const StageTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);
	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth > cardRowRef.current.clientWidth);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<StyledWrapper.CellContainer
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
			>
				<ReviewColorStageIcon
					isActive={cellValues.row.is_current_stage}
					customColor={getStatusColor(cellValues.row.status)}
				/>
				<StyledWrapper.CardRowInfo ref={cardRowRef}>
					{cellValues?.formattedValue}
				</StyledWrapper.CardRowInfo>
			</StyledWrapper.CellContainer>
		</Tooltip>
	);
};

export default StageTooltip;
